<template>
  <div class="splash">
    <div class="splash__logo">
      <StarLogo />
    </div>
  </div>
</template>

<script>
import StarLogo from '@/components/StarLogo.vue'

export default {
  name: 'SplashScreen',
  components: { StarLogo }
}
</script>

<style lang="scss" scoped>
// Séquence : écran vide, barres en fondu une à une (sens horaire depuis le haut),
// quart de tour, puis zoom qui accélère jusqu'à disparaître (sans arrêt).
.splash {
  position: fixed;
  inset: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: $navy;
  overflow: hidden;
}

.splash__logo {
  width: 240px;
  animation: splash-spin-zoom 2.6s linear forwards;

  :deep(.branch) {
    opacity: 0;
    transform-box: view-box;
    transform-origin: 45px 45px;
    // fondu d'opacité 0 -> 100 %, bien visible (linéaire)
    animation: branch-fade 0.55s linear forwards;
  }

  // ordre horaire depuis le haut : N, NE, E, SE, S, SW, W, NW
  $clockwise: (b1: 0, b5: 1, b7: 2, b6: 3, b2: 4, b3: 5, b8: 6, b4: 7);

  @each $branch, $i in $clockwise {
    :deep(.#{$branch}) {
      animation-delay: #{0.3 + $i * 0.14}s;
    }
  }

  // écarte chaque barre du centre (translate en unités SVG, après le transform d'origine)
  :deep(svg) {
    overflow: visible;
  }
  :deep(.b1 rect) { translate: 0 -2.5px; }
  :deep(.b2 rect) { translate: 0 2.5px; }
  :deep(.b7 rect) { translate: 2.5px 0; }
  :deep(.b8 rect) { translate: -2.5px 0; }
  :deep(.b5 rect) { translate: 1.8px -1.8px; }
  :deep(.b6 rect) { translate: 1.8px 1.8px; }
  :deep(.b3 rect) { translate: -1.8px 1.8px; }
  :deep(.b4 rect) { translate: -1.8px -1.8px; }
}

// apparition par simple opacité (pas d'échelle)
@keyframes branch-fade {
  from { opacity: 0; }
  to { opacity: 1; }
}

// 0-58% : attente pendant le chargement des barres,
// 58-72% : quart de tour,
// 72-100% : zoom qui accélère en continu (ease-in) jusqu'à la fin
@keyframes splash-spin-zoom {
  0%,
  58% {
    transform: rotate(0deg) scale(1);
    opacity: 1;
  }
  72% {
    transform: rotate(90deg) scale(1);
    opacity: 1;
  }
  85% {
    transform: rotate(90deg) scale(4);
    opacity: 1;
  }
  95% {
    transform: rotate(90deg) scale(13);
    opacity: 1;
  }
  100% {
    transform: rotate(90deg) scale(34);
    opacity: 0;
  }
}
</style>
